const colors = require("../../src/styles/colors");

module.exports = {
  siteTitle: "My personal website & blog!",
  shortSiteTitle: "My Personal Website & Blog",
  siteDescription:
    "A space for me to share my thoughts, questions, and attempts to answer said questions!",
  siteUrl: "https://StephanieMills.ca",
  pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",
  authorName: "Stephanie Mills",
  authorTwitterAccount: "",
  infoTitle: "Stephanie",
  infoTitle2: "Mills",
  infoTitleNote: "My Decentralized Diary",
  manifestName: "My Decentralized Diary",
  manifestShortName: "PersonalBlog", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.background,
  manifestThemeColor: colors.background,
  manifestDisplay: "standalone",
  // contact
  contactEmail: "mills.stephanie.j@gmail.com",
  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/StephanieJoyMills" },
    { name: "linkedin", url: "https://www.linkedin.com/in/stephaniejoymills/" },
    {
      name: "facebook",
      url: "https://www.facebook.com/stephanie.mills.14268?ref=bookmarks"
    }
  ]
};



// WEBPACK FOOTER //
// ./content/meta/config.js